import Lobby from "./Lobby";

export default Lobby;
